export const ROOT = "nlp-designer";
export const ROOT_HEADER = "nlp-designer__header";
export const ROOT_HEADER_SELECT = "nlp-designer__header-select";
export const ROOT_HEADER_SELECT_ITEM = "nlp-designer__header-select-item";
export const GRAPH = `${ROOT}__graph`;
export const BUTTONS_NODE = `${ROOT}__buttons-node`;
export const BUTTONS_NODE_BUTTONS = `${ROOT}__buttons-node-buttons`;
export const BUTTONS_NODE_LABEL = `${ROOT}__buttons-node-label`;
export const BUTTON = `${ROOT}__button`;
export const BUTTON_LABEL = `${ROOT}__button-label`;

export const CLASS_NAME = {
    ROOT,
    ROOT_HEADER,
    ROOT_HEADER_SELECT,
    ROOT_HEADER_SELECT_ITEM,
    GRAPH,
    BUTTONS_NODE,
    BUTTONS_NODE_BUTTONS,
    BUTTONS_NODE_LABEL,
    BUTTON,
    BUTTON_LABEL,
};
